module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "box",
      "switchLanguage": _vm.switchLanguage
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "backgroundImage"
  }), _vm._v(" "), _c('div', {
    staticClass: "headerDivPo"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('homePageIntroducesHeaderStoreTop')))]), _vm._v(" "), _c('p', [_c('span', [_vm._v(_vm._s(_vm.$t('homePageIntroducesHeaderchildTop')))]), _c('br'), _c('span', [_vm._v(_vm._s(_vm.$t('homePageIntroducesHeaderchildBot')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('homePageIntroducesContentPlan')))]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v(_vm._s(_vm.$t('homePageIntroducesContentPlanBot')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-8"
  }, [_c('div', {
    staticClass: "media-body"
  }, [_c('strong', {
    staticClass: "media-heading "
  }, [_vm._v(_vm._s(_vm.$t('homePageIntroducesContentPlatform')))]), _vm._v(" "), _c('p', {
    staticClass: "p2 mediaHeadingA"
  }, [_vm._v(_vm._s(_vm.$t('platformDeveloperProgram')))])])]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-8"
  }, [_c('div', {
    staticClass: "media-body"
  }, [_c('strong', {
    staticClass: "media-heading"
  }, [_vm._v(_vm._s(_vm.$t('homePageIntroducesContentAdvanced')))]), _vm._v(" "), _c('p', {
    staticClass: "p2 mediaHeadingB"
  }, [_vm._v(_vm._s(_vm.$t('AdvancedPevelopmentPartners')))])])]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-8"
  }, [_c('div', {
    staticClass: "media-body"
  }, [_c('strong', {
    staticClass: "media-heading"
  }, [_vm._v(_vm._s(_vm.$t('homePageIntroducesContentCustomized')))]), _vm._v(" "), _c('p', {
    staticClass: "p2 mediaHeadingC"
  }, [_vm._v(_vm._s(_vm.$t('customDevelopmentPartners')))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('img', {
    attrs: {
      "src": _vm.src,
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "47px",
      "padding-bottom": "142px"
    }
  }, [_c('div', {
    staticClass: "img-img",
    on: {
      "click": _vm.becomeDeveloperBtn
    }
  }, [_c('div', {
    staticClass: "h5"
  }, [_vm._v(_vm._s(_vm.$t('registerTitle')))])])]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('img', {
    staticClass: "footerImageA",
    attrs: {
      "src": require("../../static/img/introduces/introduces_footer_one.png"),
      "alt": "..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "footerDiv"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('homePageIntroducesBottomGuidelines')))]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.$t('homePageIntroducesBottomAbout')))]), _vm._v(" "), _c('div', {
    staticClass: "boxes",
    on: {
      "click": _vm.viewRulesBtn
    }
  }, [_c('span', {
    staticClass: "watchRules"
  }, [_vm._v(_vm._s(_vm.$t('homePageIntroducesBottomWatch')))])])]), _vm._v(" "), _c('img', {
    staticClass: "footerImageB",
    attrs: {
      "src": require("../../static/img/introduces/introduces_footer_two.png"),
      "alt": "..."
    }
  })]), _vm._v(" "), _c('BackTop')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 col-xs-4"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "media-object",
    attrs: {
      "src": require("../../static/img/introduces/introduces_platform.png"),
      "alt": "..."
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 col-xs-4"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "media-object",
    attrs: {
      "src": require("../../static/img/introduces/introduces_advanced.png"),
      "alt": "..."
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 col-xs-4"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "media-object",
    attrs: {
      "src": require("../../static/img/introduces/introduces_custom.png"),
      "alt": "..."
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-479fdb52"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Introduces.vue
// module id = 1484
// module chunks = 1